import Highcharts from "highcharts";

declare module "highcharts" {
  interface Point {
    plotX: number; // not on point really, but Typings are screwed up (we should not receive a point)
    plotY: number; // same
  }
  interface Tooltip {
    getPosition(
      boxWidth: number,
      boxHeight: number,
      point: Highcharts.Point,
    ): Highcharts.PositionObject;
  }
  interface TooltipOptions {
    position?: "top-right" | "top-left" | "top-center";
  }
}

// https://www.highcharts.com/forum/viewtopic.php?t=50646
Highcharts.AST.allowedAttributes.push("viewBox");
export default function tooltipPosition(H: typeof Highcharts) {
  H.wrap(H.Tooltip.prototype, "getPosition", function (
    this: Highcharts.Tooltip,
    proceed: Highcharts.Tooltip["getPosition"],
    ...args: Parameters<Highcharts.Tooltip["getPosition"]>
  ): ReturnType<Highcharts.Tooltip["getPosition"]> {
    const { position, outside, shared, sticky } = this.options;
    if (!position) return proceed.apply(this, args);
    if (!outside) throw new Error("Tooltip position option is only for outside tooltips");
    if (!shared) throw new Error("Tooltip position option is only for shared tooltips");
    if (sticky) throw new Error("Tooltip position option not compatible with sticky");

    const { scrollingContainer, pointer, plotLeft, container } = this.chart;
    const { left: chartLeft, top: chartTop } = pointer.getChartPosition();
    const [boxWidth, boxHeight, { plotX }] = args;

    const scrollLeft = scrollingContainer ? scrollingContainer.scrollLeft : 0;
    const chartWidth = scrollingContainer ? scrollingContainer.offsetWidth : container.offsetWidth;
    const pointX = plotX + plotLeft - scrollLeft;

    const roomLeft = boxWidth < pointX;
    const roomCenterLeft = boxWidth / 2 < pointX;
    const roomRight = pointX + boxWidth < chartWidth;
    const roomCenterRight = pointX + boxWidth / 2 < chartWidth;

    const topY = chartTop - boxHeight + 30;
    const leftX = plotX + plotLeft + chartLeft - boxWidth;
    const rightX = plotX + plotLeft + chartLeft;
    const centerX = plotX + plotLeft + chartLeft - boxWidth / 2;

    const wantLeft = position.endsWith("left");
    const wantRight = position.endsWith("right");
    const wantCenter = position.endsWith("center");

    const y = topY;

    // happy
    if (wantLeft && roomLeft) return { x: leftX, y };
    if (wantRight && roomRight) return { x: rightX, y };
    if (wantCenter && roomCenterLeft && roomCenterRight) return { x: centerX, y };

    // fallbacks
    if (!roomCenterLeft && !roomCenterRight) return { x: centerX, y }; // no room...
    if (roomCenterLeft && roomCenterRight && (wantRight || wantLeft)) return { x: centerX, y }; // can at least center...
    if (roomRight) return { x: rightX, y }; // fallback to other side
    if (roomLeft) return { x: leftX, y }; // fallback to other side
    return { x: centerX, y }; // fallback to center
  } as Highcharts.WrapProceedFunction);
}
